import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormAutocomplete } from '../shared/dynamic-form-autocomplete';

const uiGrid: UIGridElement[] = [
  { fields: { schemaID: 6 } },
  { fields: { status: 6, providerId: 6 } },
  { fields: { occupantRules: 6, teamMemberRules: 6 } },
  { fields: { externalDeliveryContainerRules: 6, internalDeliveryContainerRules: 6 } },
  { fields: { carrierCode: 6 } },
  { fields: { deactivateUsersAfterDays: 6, deliveredToRequirement: 6 } },
  { fields: { isQrDeliveryOnly: 6 } },
  { fields: { appName: 6, appInstallationUrl: 6 } }
];

export const projectModuleFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  providerId: {
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormAutocomplete {...props} />;
    }
  },
  deliveredToRequirement: {
    'ui:placeholder': 'At booking (default)',
    'ui:emptyValue': null
  },
  deactivateUsersAfterDays: {
    // Clearing the input yields null (the schema default) rather than undefined, so the setting
    // is explicitly switched off rather than omitted from the settings PUT.
    'ui:emptyValue': null
  }
};
